import { fetchWithAuth } from './fetchWithAuth';

// 목록 조회
export const fetchBoardList = async (page = 1, pageSize = 20, searchType = '', searchStatus = '', searchTitle = '') => {
  const params = new URLSearchParams({ page, pageSize });
  if (searchType)   params.append('searchType',   searchType);
  if (searchStatus) params.append('searchStatus', searchStatus);
  if (searchTitle)  params.append('searchTitle',  searchTitle);
  return fetchWithAuth(`/admin-board?${params}`);
};

// 단건 조회
export const fetchBoardOne = async (seq_no) => {
  return fetchWithAuth(`/admin-board/${seq_no}`);
};

// 등록
export const createBoard = async (body) => {
  return fetchWithAuth(`/admin-board`, { method: 'POST', body: JSON.stringify(body) });
};

// 수정
export const updateBoard = async (seq_no, body) => {
  return fetchWithAuth(`/admin-board/${seq_no}`, { method: 'PUT', body: JSON.stringify(body) });
};

// 삭제
export const deleteBoard = async (seq_no) => {
  return fetchWithAuth(`/admin-board/${seq_no}`, { method: 'DELETE' });
};

// 반응 토글
export const toggleReaction = async (seq_no, reaction_type) => {
  return fetchWithAuth(`/admin-board/${seq_no}/reaction`, { method: 'POST', body: JSON.stringify({ reaction_type }) });
};

// 댓글 등록
export const createComment = async (seq_no, content) => {
  return fetchWithAuth(`/admin-board/${seq_no}/comments`, { method: 'POST', body: JSON.stringify({ content }) });
};

// 댓글 삭제
export const deleteComment = async (seq_no, comment_no) => {
  return fetchWithAuth(`/admin-board/${seq_no}/comments/${comment_no}`, { method: 'DELETE' });
};

// 댓글 수정
export const updateComment = async (seq_no, comment_no, content) => {
  return fetchWithAuth(`/admin-board/${seq_no}/comments/${comment_no}`, { method: 'PUT', body: JSON.stringify({ content }) });
};

// 처리상태만 변경 (root 전용)
export const updateBoardStatus = async (seq_no, status) => {
  return fetchWithAuth(`/admin-board/${seq_no}/status`, { method: 'PATCH', body: JSON.stringify({ status }) });
};